<style></style>

<template>
    <base-collapse 
        class="arrow-collapse clearfix" 
            :class="'variant-'+variant" 
            :visible="visible" 
            :accordion="accordion"
        >
        <template #trigger>
            <div class="arrow"></div>
            <div class="dropdown-line" v-if="showLine"></div>
            <div class="trigger-label">
                <slot name="trigger-label"></slot>
            </div>
        </template>
        <template #collapsed-content>
            <slot name="collapsed-content"></slot>
        </template>
    </base-collapse>
</template>

<script>
import BaseCollapse from './BaseCollapse'
    export default {
        components: {
            BaseCollapse
        },
        props: {
            variant: {
                type: String,
                default: 'primary'
            },
            showLine: {
                type: Boolean,
                default: true
            },
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }
        },
        data() {
            return {}
        },
        mounted() {
        },
        methods: {}
    
}
</script>